/* Built In Imports */
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/uyirnokkam/UymSectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} UymBenefits component
 */
const UymBenefits = ({ sectionContent, region, language, bgstyle }) => {
  return (
    <Box bgColor={{base:'#FEF8E2', "2xl": 'transparent'}}>
      <Box
        className="aaa"
        bgColor={bgstyle?.bgColour?.hex || null}
        bgImage={{
          base: 'none',
          md: `url('${config.imgPath}/d/46272/1734694012-ym_benefits_bg.png')`,
          "2xl": `url('${config.imgPath}/d/46272/1737039287-uym_benefits_bg1.png')`
        }}
        bgRepeat={'no-repeat'}
        bgPosition={{md:'top right', "2xl": '1300px 0'}}
        clipPath={{
          base: `polygon(0 0, 100% 0, 100% 98%, 0% 100%)`,
          md: `polygon(0 0, 100% 0, 100% 100%, 0% 92%)`,
        }}
        pb={'30px'}
        display="flex"
        flexDirection="column"
      >
        <Box
          as="div"
          fontSize="18px"
          m="0 auto"
          width={{ base: '100%', sm: '100%', md: '737px', lg: '1100px' }}
          mb={{ md: '0', sm: '30.78px' }}
          mt={{ base: '16px', md: '30px' }}
        >
          <Box mt="50px" mb={{base:'30px', md:'70px' }}>
            {sectionContent[0].title?.length > 0 && (
              <SectionTitle
                titleObj={sectionContent[0]?.title[0]}
                lang={language}
                titlecolor={'#ffffff'}
              />
            )}
          </Box>
          <Box
            as="div"
            display="flex"
            flexWrap="wrap"
            margin="40px auto 0 auto"
            fontSize="18px"
            alignContent={'center'}
            alignItems={'self-start'}
            pb={{base:'40px', md:'0'}}
            columnGap={{base:'0', md:'90px'}}
            justifyContent={'center'}
          >
            {sectionContent &&
              sectionContent[0]?.benefits?.map((data,indx) => {
                return (
                  <Box
                    key={``}
                    mb={{ base: '10px', md: '30px', lg: '53px' }}
                    width={{ base: '235px', md: '265px', "2xl": '260px' }}
                    maxW={{ base: '240px', md:'33%' }}
                    mt={{ base: indx == 0 ? '5px' : '40px', md:'20px' }}
                  >
                    <Flex alignItems="center" justifyContent="center">
                      <LazyLoadImageComponent
                        loading="lazy"
                        src={data?.image?.url}
                        title={data?.image?.title}
                        height={{
                          base: '81px',
                          md: '80px',
                        }}
                        minW={'31px'}
                        objectFit={{ base: 'contain', md: 'cover' }}
                        m={{ base: '0 0 22px 0' }}
                      />
                    </Flex>
                    <Text
                      fontFamily={'MuktaMlalar'}
                      fontSize={{
                        base: '16px',
                        md: '18px',
                      }}
                      color="#FFF9E9"
                      m={{ base: '10px auto', lg: '0 auto 15px' }}
                      textAlign={{
                        base: 'center',
                        md: 'center',
                      }}
                      pt={{ base: '5px', sm: '10px', md: '0' }}
                    >
                      {data?.text}
                    </Text>
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UymBenefits;
